export default {"id":"c051979e","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}